export interface ILocaleStore {
    locale: string;
}

export const ILocaleStore_TYPE = Symbol.for('ILocaleStore');
